// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleListingPage_root__IX0ML","grid":"ArticleListingPage_grid__MeA_R","item":"ArticleListingPage_item__8mh4n","content":"ArticleListingPage_content__3AJVj"};